import { createFileRoute } from '@tanstack/react-router'

import { EndorsementStepPage } from '../../../../../../../components/pages/subscription-v2/endorsement-step-page.tsx'

// Keep this path pattern aligned with:
// - packages/apps/backend/src/modules/app-url/app-url-helper.ts getCustomerEndorsementStepUrl
export const Route = createFileRoute('/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId')({
  component: function Component() {
    const { endorsementId, stepId } = Route.useParams()

    // `SubscriptionV2StepPage` stores the local changes for a given step
    // We want to reset that state when the step changes
    return <EndorsementStepPage key={`${endorsementId}/${stepId}`} />
  },
})
